import api from './baseApi';

type Credentials = {
  email: string;
  password: string;
  pinCode: string;
};

export const login = async (credentials: Credentials) => {
  const response = await api.post('/auth/login/admin', credentials);
  return response;
};
